// Module
var code = "<div class=\"faq-bottom-message\" ng-bind=\"$ctrl.bottomMessage()\" ng-show=\"$ctrl.hasFaqItems\"> </div>";
// Exports
module.exports = code;